import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIntegrationSettingById,
  fetchIntegrationConfiguration,
  upsertIntegrationSetting,
  fetchIntegrationConversation,
  fetchConversationBySettingId,
} from "../../features/integration-setting/integrationSettingSlice";
import Configuration from "./Configuration";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getParticipants } from "../../features/participant/participantSlice";

function IntegrationSetting() {
  const { settingId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isOnboarding = location.pathname.includes("onboarding");
  const dispatch = useDispatch();
  const {
    setting,
    configurations,
    configLoading,
    currentConversation,
    currentConversationLoading,
  } = useSelector((state) => state.integrationSetting);

  const normalizeDefaultSettings = (defaultSettings) => {
    if (!Array.isArray(defaultSettings) || !defaultSettings.length) return {};

    return defaultSettings.reduce((acc, item) => {
      if (!item?.name || !Array.isArray(item.data)) return acc;

      acc[item.name] = item.isArray ? item.data : item.data[0] || {};

      return acc;
    }, {});
  };
  const [selectedDefaultSettings, setSelectedDefaultSettings] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(
    setting?.connectionIds?.id1 || "",
  );
  const [selectedPage, setSelectedPage] = useState(
    setting?.connectionIds?.id1 || "",
  );

  const transformDefaultSettings = (settings) => {
    return Object.entries(settings).map(([name, value]) => ({
      name,
      data: Array.isArray(value) ? value : value && value.key ? [value] : [],
      isArray: Array.isArray(value),
    }));
  };

  useEffect(() => {
    if (settingId) {
      dispatch(fetchIntegrationSettingById({ settingUuid: settingId }));
    }
  }, [settingId, dispatch]);

  useEffect(() => {
    if (settingId) {
      dispatch(
        fetchIntegrationConfiguration({ settingUuid: settingId, teamId: null }),
      );
    }
  }, [settingId, dispatch]);

  useEffect(() => {
    if (settingId) {
      dispatch(fetchConversationBySettingId(settingId));
    }
  }, [settingId, dispatch]);

  useEffect(() => {
    if (setting?.defaultSettings && setting?.defaultSettings.length > 0) {
      setIsUpdateMode(true);
    }

    if (setting?.connectionIds?.id1) {
      setSelectedTeam(setting.connectionIds.id1);
      setSelectedPage(setting.connectionIds.id1);
    }

    setSelectedDefaultSettings(
      normalizeDefaultSettings(setting?.defaultSettings),
    );
  }, [setting]);

  const handleTeamChange = async (id) => {
    setSelectedTeam(id);

    dispatch(
      fetchIntegrationConfiguration({
        settingUuid: settingId,
        teamId: id,
      }),
    );
  };

  const handlePageChange = (id) => {
    setSelectedPage(id);
  };

  const handleSave = async () => {
    try {
      const data = {
        uuid: settingId,
        integrationId: setting?.integrationId?.uuid,
        defaultSettings: transformDefaultSettings(selectedDefaultSettings),
        connectionIds: {
          id1: selectedPage || selectedTeam || setting?.connectionIds?.id1 || null,
        },
        isInstallationCompleted: true,
      };

      await dispatch(upsertIntegrationSetting(data));
      await dispatch(getParticipants());
      toast.success(`Configurations updated successfully`);

      await dispatch(fetchIntegrationConversation());
      await dispatch(fetchConversationBySettingId(settingId));

      navigate(
        isOnboarding
          ? `/onboarding/team-communication/integrations`
          : `/integrations`,
      );
    } catch (error) {
      console.error("Error updating setting:", error);
    }
  };

  return (
    <Configuration
      setting={setting}
      configurations={configurations}
      loading={configLoading}
      selectedDefaultSettings={selectedDefaultSettings}
      setSelectedDefaultSettings={setSelectedDefaultSettings}
      handleSave={handleSave}
      isOnboarding={isOnboarding}
      isUpdateMode={isUpdateMode}
      selectedTeam={selectedTeam}
      handleTeamChange={handleTeamChange}
      selectedPage={selectedPage}
      handlePageChange={handlePageChange}
      conversation={currentConversation}
      conversationLoading={currentConversationLoading}
    />
  );
}

export default IntegrationSetting;
